class HiddenVersion {
    constructor(parent, data) {
        this.parent = parent
        this.data = data
    }
    run() {
        document.querySelectorAll('[data-hidden-version]').forEach((el) => new HiddenVersionItem(el, this))
    }
}

class HiddenVersionItem {
    constructor(item, parent) {
        this.item = item
        this.parent = parent
        this.init()
    }
    init() {
        this.id = this.item.dataset.hiddenVersion
        this.content = document.querySelector('[data-hidden-version-content="' + this.id + '"]')
        if (!this.content) {
            return
        }
        this.content.style.setProperty('--max-height', Math.round(this.content.getBoundingClientRect().height) + 'px')
        this.content.classList.add('hidden-version--is-hidden')
        this.item.addEventListener('click', () => {
            this.content.classList.toggle('hidden-version--is-hidden')
        })
    }
}

export default HiddenVersion